/** The strings for this feature, in the active language — see src/lib/i18n.js. */
import { pickLocale } from '../../lib/i18n'
import * as ar from './strings.ar'
import * as en from './strings.en'

export const templatesStrings = pickLocale(ar.templatesStrings, en.templatesStrings)
export const campaignsStrings = pickLocale(ar.campaignsStrings, en.campaignsStrings)
export const phishingSettingsStrings = pickLocale(ar.phishingSettingsStrings, en.phishingSettingsStrings)
export const reportStrings = pickLocale(ar.reportStrings, en.reportStrings)
